import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import './i18n';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/es" element={<App language="es" />} />
      <Route path="/en" element={<App language="en" />} />
      <Route path="/" element={<App language="es" />} />
    </Routes>
  </BrowserRouter>
);